<script lang="ts">
import PhxsgCoreCenter from '@sg-core/src/View/Components/Atoms/Center/phxsg-center.vue';

export interface PhxsgContainerProps {
  size?: 'tight' | 'xs' | 'sm' | 'md';
  use?: keyof HTMLElementTagNameMap;
  withGrid?: boolean;
}
</script>

<script setup lang="ts">
const { size = 'md', use = 'div', withGrid = false } = defineProps<PhxsgContainerProps>();
</script>

<template>
  <PhxsgCoreCenter
    :use="use"
    :class="[
      'phxsg-container',
      {
        [`phxsg-container--${size}`]: size,
        'phxsg-container--grid': withGrid,
      },
    ]"
  >
    <slot />
  </PhxsgCoreCenter>
</template>

<style src="./container.css" />
